import { render, staticRenderFns } from "./TheContents.vue?vue&type=template&id=aaeb1422&"
import script from "./TheContents.vue?vue&type=script&lang=js&"
export * from "./TheContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports